<template>
  <vue-html2pdf
  class="main-content"
    :show-layout="true"
    :float-layout="false"
    :enable-download="true"
    :preview-modal="false"
    :paginate-elements-by-height="1400"
     :filename="invoice ? invoice.number : 'Invoice'"
    :pdf-quality="2"
    :manual-pagination="false"
    pdf-format="a4"
    pdf-orientation="portrait"
    :pdf-content-width="contentWidth"
    ref="html2Pdf"
    @hasDownloaded="restoreHeader"
  >
    <section slot="pdf-content">
      <div id="invoice-view">
        <div class="invoice-control-section" :style="headerStyle">
          <button class="back-to-invoice-button" @click="goToinvoicePage">
            <span>All Invoices</span>
          </button>
          <div id="download-print-buttons" class="buttons">
            <span @click="printInvoice"><i class="fa fa-print" /></span>
            <span @click="downloadAsPdf"><i class="fa fa-download" /></span>
          </div>
        </div>
        <div id="invoice-download" class="invoice-preview">
          <loader />
          <img class="logoPng" src="../../assets/img/cc.png" alt="" />
          <div class="previewLogo">
            <p class="logo-text">Carrier Community</p>
            <p class="sub-text">GLOBAL TELECOM CLUB</p>
          </div>
          <div class="invoice">
            <p>Invoice</p>
          </div>

          <div>
            <div class="info">
              <div v-if="invoice && financialEntity" class="companyInfo">
                <b>FROM:</b> <br />
                <span style="color: #bd9d5f">{{
                  financialEntity.name || ""
                }}</span
                ><br />
                <span> {{ financialEntity.billing_address || "" }}</span
                ><br />
                <span>
                  {{ financialEntity.city || "" }}
                  {{ financialEntity.postal_code || "" }}</span
                ><br />

                <span> {{ financialEntity.country || "" }}</span
                ><br />
                <span>Phone: {{ financialEntity.phone_number || "" }}</span
                ><br />
                <span>Email: {{ financialEntity.email || "" }}</span
                ><br />
                <span>VAT Number: {{ financialEntity.vat_number || "" }}</span
                ><br />

                <b>To:</b> <br />
              <div v-if="invoice.company_billing_address">
                  <span>{{ invoice.company_billing_address_details.name }}</span><br>
                  <span>{{ invoice.company_billing_address_details.address }},
                    {{ invoice.company_billing_address_details.zip_code }}</span><br>
                  <span>
                    {{ invoice.company_details.finance_contact_email }}</span><br>
                  <span>Tel: {{ invoice.company_details.mobile_number }}</span><br>
                  <span>Website: {{ invoice.company_details.website }}</span><br>
                  <span>VAT Number:
                    {{ invoice.company_billing_address_details.vat_number }}</span><br>
                  <span style="color: #bd9d5f;">{{ invoicedTo.name }}</span><br>
                  <span>{{ invoicedTo ? invoicedTo.phone_number : '' }}</span><br>
                </div>
                <div v-else>
                  <span>{{ invoice.company_details.name }}</span><br>
                  <span>{{ invoice.company_details.address }},
                    {{ invoice.company_details.zip_code }}</span><br>
                  <span>
                    {{ invoice.company_details.finance_contact_email }}</span><br>
                  <span>Tel: {{ invoice.company_details.mobile_number }}</span><br>
                  <span>Website: {{ invoice.company_details.website }}</span><br>
                  <span>VAT Number:
                    {{ invoice.company_details.vat_number }}</span><br>
                  <span style="color: #bd9d5f;">{{ invoicedTo.name }}</span><br>
                  <span>{{ invoicedTo ? invoicedTo.phone_number : '' }}</span><br>
                </div>
              </div>
              <div class="invoiceInfoList">
                <table v-if="invoice" border="1" style="border: 1px solid gray; font-size: 13px;">
                  <tr v-if="financialEntity">
                    <td><b>Invoice Number</b></td>
                    <td>
                      {{ invoice.number }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>PO Number</b>
                    </td>
                    <td>{{ invoice.po_number }}</td>
                  </tr>
                  <tr>
                    <td><b>Issue Date</b></td>
                    <td>{{ formatedIssueDate }}</td>
                  </tr>
                  <tr>
                    <td><b>Due Date</b></td>
                    <td>{{ formatedDueDate }}</td>
                  </tr>
                   <tr>
                    <td><b>Open Balance Due</b></td>
                    <td> {{ invoice.currency_code }} {{ invoice.deficit_loss  }}</td>
                  </tr>
                  <tr>
                    <td><b>Paid Amount</b></td>
                    <td> {{ invoice.currency_code }} {{ invoice.net_amount || 0 }}</td>
                  </tr>
                  <tr class="tr-style">
                    <td>Total Due</td>
                    <td>
                      {{ invoice.currency_code }}
                      {{ totalDue }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="eventBook">
              <table border="1" class="eventInfo">
                <tr class="tr-style">
                  <td>Hrs/Qty</td>
                  <td>Service</td>
                  <td>Rate/Price</td>
                  <td>Discount</td>
                  <td>Sub Total</td>
                </tr>
                <tr
                  v-for="(info) in previewData"
                  :key="info.id"
                  class="largeTr"
                >
                  <td style="text-align: left">
                    {{ `${info.quantity}.00` }}
                  </td>
                  <td style="text-align: left">
                    <b>
                      {{
                        `${event.name || award.name} ${event.city || award.city}
                    ${
                      moment(event.start_date).format("DD") ||
                      moment(award.start_date).format("DD")
                    } -
                    ${
                      moment(event.end_date).format("DD") ||
                      moment(award.end_date).format("DD")
                    }
                    ${
                      moment(event.start_date).format("MMMM") ||
                      moment(award.start_date).format("MMMM")
                    }
                    ${
                      moment(event.end_date).format("YYYY") ||
                      moment(award.end_date).format("YYYY")
                    }`
                      }}
                    </b>
                    <br />
                    <p style="text-indent: 5px; margin: 0">
                      {{ info.name }}
                    </p>
                  </td>
                  <td style="text-align: right">
                    {{
                      `${invoice.currency_code} ${
                        info.amount
                      },00`
                    }}
                  </td>
                  <td
                    style="text-align: right"
                    v-if="info.adjustment_details.length"
                  >
                    {{
                      `${invoice.currency_code} ${
                        info.adjustment_details[0].amount
                      }`
                    }}
                  </td>
                  <td style="text-align: right" v-else>
                    {{ `${invoice.currency_code} 0` }}
                  </td>
                  <td
                    style="text-align: right"
                    v-if="info.adjustment_details.length"
                  >
                    {{
                      `${invoice.currency_code} ${
                        info.quantity * info.amount -
                       info.adjustment_details[0].amount
                      }`
                    }}
                  </td>
                  <td style="text-align: right" v-else>
                    {{
                      `${invoice.currency_code} ${
                        info.quantity * info.amount
                      }`
                    }}
                  </td>
                </tr>
                 <tr
                  v-for="price in extraAmounts"
                  :key="price.id"
                  class="largeTr"
                >
                  <td style="text-align: left">
                    {{ `${price.quantity}.00` }}
                  </td>
                  <td style="text-align: left">
                    <b>Multiple
                    </b>
                    <br>
                    <p style="text-indent: 5px; margin: 0">
                      {{ price.name }}
                    </p>
                  </td>
                  <td style="text-align: right">
                    {{
                      `${invoice.currency_code} ${
                        price.amount
                      },00`
                    }}
                  </td>
                  <td
                    style="text-align: right"
                  >
                    {{
                      `${invoice.currency_code} ${
                        price.adjustment_amount
                      }`
                    }}
                  </td>
                  <td
                    style="text-align: right"
                  >
                    {{
                      `${invoice.currency_code} ${
                        price.quantity * price.amount -
                        price.adjustment_amount
                      }`
                    }}
                  </td>
                </tr>
              </table>
            </div>
            <div class="adjustInfo">
              <div />
              <table v-if="invoice" style="border: 1px solid gray" border="1">
                <tr>
                  <td><b>Sub Total</b></td>
                  <td>
                    {{
                      `${
                        invoice.currency_code
                      } ${subTotal}`
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <b>VAT ({{ invoice.vat }}%)</b>
                  </td>
                  <td>
                    {{
                      `${
                        invoice.currency_code
                      } ${vatPercent}`
                    }}
                  </td>
                </tr>
                <tr class="tr-style">
                  <td>Total Due</td>
                  <td>
                    {{
                      `${
                        invoice.currency_code
                      } ${totalDue}`
                    }}
                  </td>
                </tr>
              </table>
            </div>
           <div v-if="paymentPlan.length">
              <b> Payment Plan: </b><br>
           <span
                v-for="(step, index) in paymentPlan"
                :key="index"
              >
                {{ index + 1 }}. {{ step.description }} <b>Due date:</b>
                {{ step.due_date }} <b>Due:</b>
                {{ invoice.currency_code }} {{ step.amount
                }}<br></span>
            </div>
            <br />
            <p class="financialInfo">
              Account Name: {{ bankAccount.holder }}<br />
              Swift/BIC Code: {{ bankAccount.BIC_SWIFT }} <br />
              IBAN: {{ bankAccount.IBAN }} <br />
              BLZ: {{ bankAccount.BLZ }}<br />
              Account Number: {{ bankAccount.account_number }}<br />
              Bank Name: {{ bankAccount.bank_name }}<br />
              <span v-if="financialEntity"
                >Bank Address:
                {{
                  financialEntity.bank_address ||
                  financialEntity.bank_address_additional_line
                }}
              </span>
            </p>
            <div v-if="invoice" class="invoiceNotes">
              <p v-if="invoice" v-html="invoice.notes" class="note-text"></p>
              <p
                style="text-align: center; margin-bottom: 0"
                v-html="
                  invoice.footer ||
                  '<span>Thank you for your business and support</span>'
                "
              ></p>
              <p v-if="invoice.payment_date && invoice.status == 'paid'" style="text-align: center">
                <b
                  >Paid via {{ `${methods[invoice.method]}` }} on the date:
                  {{
                    `${moment(invoice.payment_date).format("DD.MM.YYYY")}`
                  }}</b
                >
              </p>
                <p v-else-if="invoice.status == 'cancelled'" style="text-align: center">
                <b
                  >Cancelled</b
                >
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
          v-if="invoiceParticipants.length > 0"
          class="invoice-participants-container invoice-preview"
        >
          <b>Attending Employees: </b><br>
          <div class="invoice-participants">
            <p>{{ invoiceParticipants.map(ip => ip.details.name).join(', ') }}</p>
          </div>
      </div>
      
      <div v-if="invoice.second_page" id="second-page" class="invoice-preview">
        <p v-html="invoice.second_page"></p>
      </div>
    </section>
  </vue-html2pdf>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import moment from 'moment';
import VueHtml2pdf from 'vue-html2pdf';
import Loader from '../../components/additions/Loader.vue';

export default {
  name: 'InvoicePreview',
  components: {
    Loader,
    VueHtml2pdf,
  },
  data() {
    return {
      paymentPlan: [],
      invoice: null,
      event: {},
      award: {},
      methods: {
        1: 'PayPal',
        2: 'Credit Card',
        3: 'Bank',
      },
      previewData: null,
      extraAmounts: null,
      subTotal: 0,
      vatPercent: 0,
      totalDue: 0,
      bankAccount: {},
      financialEntity: null,
      invoicedTo: null,
      headerStyle: { },
      contentWidth: '1000px',
      invoiceParticipants: [],
    };
  },
  computed: {
    formatedIssueDate() {
      return moment(this.invoice.created).format('DD/MM/YYYY');
    },
    formatedDueDate() {
      return moment(this.invoice.due_date).format('DD/MM/YYYY');
    },
    ...mapGetters({
      isMobileScreen: 'isMobileScreen',
    }),
  },
  async mounted() {
    const config = {
      headers: { Authorization: `Bearer ${this.$store.getters['auth/access']}` },
    };
    try {
      const { invoiceId } = this.$route.params;
      if (!invoiceId) {
        this.$router.push({ path: '/not-found' });
      }
      this.paymentPlan = await this.getPaymentSteps(invoiceId);

      const invoice = await this.fetchInvoiceById(invoiceId);
      if (!invoice) this.$router.push({ path: '/not-found' });
      else this.invoice = { ...invoice };
      if (this.invoice.event) {
        const eventData = await axios(this.invoice.event, config);
        this.event = { ...eventData.data };
      } else if (this.invoice.award) {
        const awardData = await axios(this.invoice.award, config);
        this.award = { ...awardData.data };
      }
      const res = await axios(this.invoice.bank_account);
      this.bankAccount = res.data;
      this.previewData = [...this.invoice.price_details];
      this.extraAmounts = [...this.invoice.extra_amounts];

      this.subTotal = this.previewData
        .map((el) => {
          if (el.adjustment_details.length) {
            return (
              el.quantity * el.amount - el.adjustment_details[0].amount
            );
          }
          return el.quantity * el.amount;
        })
        .reduce((prev, curr) => prev + curr, 0);

      this.subTotal = this.extraAmounts
        .map(el => el.quantity * el.amount - el.adjustment_amount)
        .reduce((prev, curr) => prev + curr, this.subTotal);
      const { data } = await axios(this.invoice.financial_entity, config);
      this.financialEntity = data;
      this.vatPercent = Number(
        ((this.subTotal * this.invoice.vat) / 100).toFixed(2),
      );
      this.totalDue = this.invoice.amount;
      this.invoicedTo = this.invoice.invoiced_to_details;
      this.invoiceParticipants = await this.getInvoiceParticipants(invoiceId);
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    ...mapActions({
      fetchInvoiceById: 'invoice/fetchInvoiceById',
      startLoading: 'startLoading',
      endLoading: 'endLoading',
      getPaymentSteps: 'invoice/getPaymentSteps',
      getInvoiceParticipants: 'invoice/getInvoiceParticipants',
    }),
    moment(date) {
      return moment(new Date(date));
    },
    goToinvoicePage() {
      this.$router.push({ name: 'Settings/Invoices' });
    },
    printInvoice() {
      window.print();
    },
    restoreHeader() {
      this.headerStyle = { display: 'block' };
      this.contentWidth = this.isMobileScreen ? '100%' : '1000px';
    },
    downloadAsPdf() {
      this.headerStyle = { display: 'none' };
      this.contentWidth = '800px';
      this.$refs.html2Pdf.generatePdf();
    },
  },
  watch: {
    isMobileScreen: {
      immediate: true,
      handler(val) {
        if (val) {
          this.contentWidth = '100%';
        } else {
          this.contentWidth = '1000px';
        }
      },
    },
  },
};
</script>
<style>
#invoice-view, #second-page {
  margin-top: 10px;
}
.main-content{
  margin:auto;
}
.invoice-control-section {
  margin: 0 0 1px;
  padding: 16px 4%;
  background-color: #fff;
  border-radius: 0 10px 0 0;
}
.invoice-preview {
  background-color: #fff;
  padding: 10px 18px;
}
.previewLogo {
  display: inline-block;
  margin: 5px;
  padding-top: 10px;
}
.logoPng {
  display: block;
  float: left;
  width: 48px;
  height: 48px;
}

.logo-text {
  font-weight: bold;
  font-size: 25px;
  margin: 0;
  margin-top: -16px;
}
.sub-text {
  color: #bd9d5e;
  font-size: 10px;
  margin-top: -7px;
}
.invoice {
  float: right;
  margin-top: 0;
}
.invoice p {
  font-weight: bold;
  font-size: 24px;
}
.companyInfo {
  font-size: 13px;
}
.info {
  display: grid;
  grid-template-columns: 1fr 30%;
  grid-column-gap: 30%;
  margin-bottom: 15px;
}
.invoiceInfoList table {
  width: 100%;
}
.invoiceInfoList table tr td {
  text-align: right;
  padding-right: 2px;
}
.eventInfo {
  border: 1px solid gray;
}
.eventInfo td {
  text-align: center;
  padding-right: 3px;
  text-indent: 4px;
}

.eventBook {
  display: grid;
  grid-template-columns: 1fr;
}
.largeTr {
  height: 6vh;
}
.adjustInfo {
  margin: 5px 0;
  display: grid;
  grid-template-columns: 1fr 30%;
}
.adjustInfo table tr td {
  text-align: right;
  padding-right: 5px;
}
.buttons {
  float: right;
  justify-content: flex-end;
  color: #bd9d5f;
}
.buttons i {
  font-size: 20px !important;
  cursor: pointer;
}
.note-text {
  text-align: center;
  color: grey;
}
.tr-style {
  background-color: #ebebeb;
  font-weight: bold;
  color: #333333;
}
#download-print-buttons > span,
.back-to-invoice-button {
  background-color: #bd9d5e;
  border: unset;
  color: #fff;
  border: 1px solid transparent;
  border-radius: 10px 10px 10px 0;
  cursor: pointer;
  padding: 4px 8px;
}
.back-to-invoice-button:hover {
  background-color: #fff;
  color: #bd9d5f;
  border: 1px solid #bd9d5f;
}
#download-print-buttons {
  margin-top: 5px;
}
#download-print-buttons > span {
  margin: 0 4px 0 0;
  background-color: transparent;
  color: #bd9d5f;
}
.financialInfo {
  background-color: #ebebeb;
  padding: 1%;
}
.invoiceNotes  p{
    margin-bottom: 5px;
  }
@media print {
  .breadcrumb,
  .app-footer,
  .sidebar,
  .footer,
  .buttons,
  .invoice-control-section {
    display: none;
  }
  table {
    page-break-inside: avoid;
    border: 1px solid gray !important;
  }
}
@page {
  /* size: A4; */
  margin: 0;
  padding: 0;
}
@media (max-width: 1024px) {
  .invoice-control-section {
    border-radius: 0 10px 0 0;
  }
  .invoice-preview {
    border-radius: 0;
  }
  #download-print-buttons > span,
  .back-to-invoice-button {
    background-color: #f3f3f3;
    color: #7f7f7f;
    border: 1px solid transparent;
    border-radius: 0 10px 10px 10px;
  }
  .invoice p {
    font-size: 8px;
  }
  .companyInfo,
  .invoiceInfoList table tr td,
  .eventBook table tr td,
  .adjustInfo table tr td,
  .financialInfo {
    font-size: 4px;
  }
  .largeTr {
    height: 4vh;
  }
  .logo-text {
    font-size: 12px;
  }
  .sub-text,
  .invoiceNotes {
    font-size: 7px;
    margin-top: -3px;
  }
  .logoPng {
    width: 25px;
    height: 25px;
  }
}

.invoice-participants {
  display: flex;
  gap: 10px;
}
</style>
